import PropTypes from 'prop-types';
import React from 'react';
import CloseIcon from '@components/icons/close.svg';
import StyledCloseModal from './closeModal.style';

const CloseModal = ({ closeModal }) => {
  return (
    <StyledCloseModal>
      <button type="button" className="close-modal__icon" onClick={closeModal}>
        <CloseIcon width="26" height="26" role="presentation" />
      </button>
    </StyledCloseModal>
  );
};

CloseModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default CloseModal;
